import { HttpAdapter } from '../HttpAdapter';
import { basicConfig } from '../../config';

export class TestService {
  static getTest = (testId: string, config = {}) => {
    return HttpAdapter.get(`${basicConfig.gridFitApi}/api/test/${testId}/light`, config);
  };
}
